import _ from 'lodash';
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from "moment";
import FMPHeadline from "../../components/ui/FMPHeadline";
import Button from "@material-ui/core/Button";
import Search from "@material-ui/icons/Search";
import StationInvoicesContainer from '../../containers/accounting/StationInvoices';
import BulkInvoicesContainer from '../../containers/accounting/BulkInvoices';
import BulkCustomersContainer from '../../containers/logistics/BulkCustomers';
import StationsContainer from '../../containers/Stations';
import CarriersContainer from '../../containers/logistics/Carriers';
import TerminalsContainer from '../../containers/logistics/Terminals';
import SuppliersContainer from '../../containers/logistics/Suppliers';


import FMPDatePicker from "../../components/pureForm/FMPDatePicker";
import FMPBulkCustomerSelect from "../../components/pureForm/FMPBulkCustomerSelect";
import FMPSelect from "../../components/pureForm/FMPSelect";
import FMPSectionHeader from "../../components/ui/FMPSectionHeader";

import FMPStationSelect from "../../components/pureForm/FMPStationSelect";
import FMPCarrierSelect from "../../components/pureForm/FMPCarrierSelect";
import FMPTerminalSelect from "../../components/pureForm/FMPTerminalSelect";
import FMPSupplierSelect from "../../components/pureForm/FMPSupplierSelect";
import FMPText from "../../components/pureForm/FMPText";
import {getDocuments} from "./general";
import {sortTable, PureRecordRow} from "../../libs/utility";
import { invoiceSearchProducts } from '../../libs/products';

import Table from "@material-ui/core/Table";
import EnhancedTableHead from "../../components/EnhancedTableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";

import {
	invoiceStatusClassNames,
	statusToDisplay,
	moneyFormatter,
} from './general';
import InvoiceDocumentIcon from "../../components/ui/invoiceDocumentIcon";
import invoiceIcon from "../../images/invoicePdf.svg";
import quickbooksLogo from "../../images/quickbooksLogo.svg";
import CircularProgress from "@material-ui/core/CircularProgress";
import InvoiceDocumentPopup from "../../components/Dialogs/InvoiceDocumentPopup";
import InvoicePdfPopup from "../../components/Dialogs/InvoicePdfPopup";
import ViewStationInvoiceLogDialog from "../../components/Dialogs/ViewStationInvoiceLogDialog";
import ViewBulkInvoiceLogDialog from "../../components/Dialogs/ViewBulkInvoiceLogDialog";
import FMPProductSelect from "../../components/pureForm/FMPProductSelect";

const styles = (theme) => {
	return {
		...invoiceStatusClassNames,
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign : 'left',
			boxSizing: 'border-box',
			padding : 25,
			paddingBottom : 30,
			marginTop : 10,
			[theme.breakpoints.up('md')]: {
				padding : '30px 40px 40px 40px',
			}
		},
		bigButton : {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize : 16
		},
		smallButton : {
			borderRadius: '100px',
			fontWeight : 200,
		},
		pickPlease : {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding : 20,
			color : '#666'
		},
		divider : {
			borderBottom : '1px dashed #dddddd',
			marginBottom : 25,
			marginTop : 25,
		},
		stats : {
			padding : '20px 10px 20px 10px',
			borderBottom : '1px solid #ddd',
			marginBottom : 10,
		},
		statGroup : {
			padding : '5px 5px 10px 5px',
			borderBottom : '1px solid #eee',
			marginBottom : 10,
		},
		available : {
			fontWeight : 900,
		},
		invoiceDocument : {
			position : 'absolute',
		},
		invoiceDocumentContainer : {
			position : 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor : 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor : 'pointer',
		},
		table : {
			width: '100%',
			tableLayout: 'auto',
		},
		row : {
			cursor : 'pointer',
		},
		button: {
			verticalAlign : 'middle',
			padding : '8px 10px',
		},
		resultsHere : {
			padding : 30,
			backgroundColor : '#f1f1f1',
			color : '#777',
			borderRadius : 10,
		},
		runningSearch : {
			paddingLeft : 20,
			display : 'flex',
			alignItems : 'center',
			fontSize : 18,
			color :  '#666',
		}
	};
};

const stationColumns = [{
	id: 'stationInvoiceId',
	label: 'Invoice #',
	padding : 'checkbox',
}, {
	id: 'deliveryInfo',
	label: 'Delivery Info',
	padding: 'checkbox',
}, {
	//id: 'invoiceTotal',
	id: 'issueDateSort',
	label: 'Invoice Info',
	padding : 'checkbox',
}, {
	id: 'invoiceInfo',
	label: 'Invoice Fuels',
	padding : 'checkbox',
}, {
	id: 'documentInfo',
	label: 'Documents',
	padding : 'checkbox',
}, {
	id: 'invoicePdf',
	label: 'Invoice PDF',
	padding : 'checkbox',
}, {
	id: 'quickbooksInvoiceUrl',
	label : 'QB Url',
	padding : 'checkbox',
}, {
	id: 'status',
	label: 'Status',
	padding : 'checkbox',
}, {
	id: 'edit',
	padding : 'checkbox',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];


const bulkColumns = [{
	id: 'bulkInvoiceId',
	label: 'Invoice #',
	padding : 'checkbox',
}, {
	id: 'deliveryInfo',
	label: 'Delivery Info',
	padding: 'checkbox',

}, {
	id: 'issueDateSort',
	label: 'Invoice Info',
	padding : 'checkbox',
}, {
	id: 'invoiceInfo',
	label: 'Fuel Info',
	padding : 'checkbox',
}, {
	id: 'documentInfo',
	label: 'Documents',
	padding : 'checkbox',
}, {
	id: 'invoicePdf',
	label: 'Invoice PDF',
	padding : 'checkbox',
}, {
	id: 'quickbooksInvoiceUrl',
	label : 'QB Url',
	padding : 'checkbox',
}, {
	id: 'status',
	label: 'Status',
	padding : 'checkbox',
}, {
	id: 'edit',
	padding : 'checkbox',
	label : 'Edit',
	style : {textAlign : 'center'},
	isNotSortable : true,
}];

class InvoiceSearch extends Component {
	constructor(props){
		super(props);
		this.state = {
			formFieldError: {},
			invoiceType : '',
			afterDate : moment().subtract(15, 'days').format('YYYY-MM-DD'),
			beforeDate : moment().format('YYYY-MM-DD'),
			searchResultRows : undefined,
			order: 'desc',
			orderBy: 'stationInvoiceId',
			isSearching : false,
		};
	}

	componentDidMount () {
		//- Only used for updates
		const {
			bulkCustomers, searchBulkCustomers,
			stations, searchStations,
			terminals, searchTerminals,
			suppliers, searchSuppliers,
			carriers, searchCarriers,
		} = this.props;

		if (_.isEmpty(bulkCustomers)) { searchBulkCustomers(); }
		if (_.isEmpty(stations)) { searchStations(); }
		if (_.isEmpty(carriers)) { searchCarriers(); }
		if (_.isEmpty(terminals)) { searchTerminals(); }
		if (_.isEmpty(suppliers)) { searchSuppliers(); }
	}

	onChange = (value, path) => {
		const arrayPath = (_.isString(path))
			? _.toPath(path)
			: path;

		const val = (_.isObject(value) && value.target)
			? value.target.value
			: value;

		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), val);
			newState[basePath] = base;
		} else {
			newState[basePath] = val;
		}

		this.setState(newState);
	};

	getInputProps = (path) => {
		return {
			path,
			value  : this.getValue(path),
			error : this.getError(path),
			onChange : this.onChange,
			md : 6,
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};
	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	submitStationSearch = () => {
		const {
			advancedSearchStationInvoices,
			showErrors,
		} = this.props;

		const formFieldError = {};
		const requiredFields = [
			{path: 'afterDate', label: 'After Date'},
			{path: 'beforeDate', label: 'Before Date'},
		];

		requiredFields.forEach(({path, label})=> {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const {
			afterDate,
			beforeDate,
		} = this.state;


		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			afterDate : afterMoment.format('YYYY-MM-DD'),
			beforeDate : beforeMoment.format('YYYY-MM-DD'),
		};

		[
			'stationId', 'carrierId',
			'firstTerminalTerminalId', 'firstTerminalSupplierId',
			'secondTerminalTerminalId', 'secondTerminalSupplierId',
		].forEach(s => {
			if (this.state[s])  {
				params[`${s}s`] = [this.state[s]];
			}
		});

		['productType', 'fuelPickupType', 'bolNumber', 'carrierPoNumber'].forEach(s => {
			if (this.state[s])  {
				params[s] = this.state[s];
			}
		});

		this.setState({
			isSearching: true,
		});

		setTimeout(() => {
			advancedSearchStationInvoices({
				params,
				callback: (err, r) => {
					this.setState({isSearching: false});
					if (err) {
						return showErrors((_.isArray(err)) ? err : [err]);
					}

					const searchResultRows = _.get(r, 'collections.stationInvoiceCollection', []);
					this.setState({
						savingStatus: 'done',
						searchResultRows,
						searchResultBulkRows : undefined,
					});
				}
			});
		}, 250);
	};


	submitBulkSearch = () => {
		const {
			advancedSearchBulkInvoices,
			showErrors,
		} = this.props;

		const formFieldError = {};
		const requiredFields = [
			{path: 'afterDate', label: 'After Date'},
			{path: 'beforeDate', label: 'Before Date'},
		];

		requiredFields.forEach(({path, label})=> {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const {
			afterDate,
			beforeDate,
		} = this.state;


		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			afterDate : afterMoment.format('YYYY-MM-DD'),
			beforeDate : beforeMoment.format('YYYY-MM-DD'),
		};

		[
			'bulkCustomerId', 'carrierId',
			'offloadTerminalId',
			'pickupTerminalId', 'pickupSupplierId',
		].forEach(s => {
			if (this.state[s])  {
				params[`${s}s`] = [this.state[s]];
			}
		});

		['bolNumber', 'carrierPoNumber'].forEach(s => {
			if (this.state[s])  {
				params[s] = this.state[s];
			}
		});

		this.setState({
			isSearching: true,
		});

		setTimeout(() => {
			advancedSearchBulkInvoices({
				params,
				callback: (err, r) => {
					this.setState({isSearching: false});
					if (err) {
						return showErrors((_.isArray(err)) ? err : [err]);
					}

					const searchResultBulkRows = _.get(r, 'collections.bulkInvoiceCollection', []);
					this.setState({
						savingStatus: 'done',
						searchResultBulkRows,
						searchResultRows : undefined,
					});
				}
			});
		}, 250);
	};

	formatIssuedStationInvoices  = ({ stationInvoices}) => {

		return stationInvoices.map(stationInvoice => {
			const {
				stationMap,
				carrierMap,
				invoiceDocumentMap,
				stationDeliveryMap,
				terminalMap,
				//resourceMap,
				supplierMap,
			} = this.props;

			const {
				stationInvoiceId,
				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				//deliveryWindowEndDateTime,
				invoiceDocumentIds,
				issueDate,
				//dateCreated,
				collatedResourceId,
				quickbooksInvoiceUrl,
			} = stationInvoice;

			const station = stationMap[stationId] ||
				{number: '', name: 'MISSING STATION'};
			const stationDisplay = `${station.number} - ${station.name}`;

			//- Delivery
			let stationDelivery;
			let deliveryInfo = (<span>Not linked</span>);
			if (linkedStationDeliveryId) {
				stationDelivery = stationDeliveryMap[linkedStationDeliveryId];
				if (!stationDelivery) {
					deliveryInfo = (<span>Delivery {linkedStationDeliveryId} not found</span>);
				} else {
					const {
						deliveryWindowEndDateTime,
						stationDeliveryId,
					} = stationDelivery;

					const dateDisplay = moment(deliveryWindowEndDateTime).format('ddd, M/D');
					deliveryInfo = (<Fragment>
						<div>{stationDisplay}</div>
						<div>Delivery #{stationDeliveryId}</div>
						<div>{dateDisplay}</div>
					</Fragment>);
				}
			}


			//- Station Invoice
			const invoiceDocuments = invoiceDocumentIds.map(invoiceDocumentId => {
				return invoiceDocumentMap[invoiceDocumentId] || {name: 'MISSING'};
			});

			const {uploadedInvoiceDocuments, missingInvoiceDocuments} = getDocuments({
				stationDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});

			//- InvoiceInfo
			const invoiceLines = [];
			if (!_.isEmpty(missingInvoiceDocuments)) {
				invoiceLines.push('No documents yet');
			} else {
				const {products} = stationInvoice;
				if (_.isEmpty(products)) {
					invoiceLines.push('No fuels yet');
				} else {
					//let invoiceE85 = 0;
					products.forEach(product => {
						const {productType, terminalSupplier, netGallons} = product;
						let terminalDisplay = 'No terminal yet';
						if (terminalSupplier) {
							const terminal = terminalMap[terminalSupplier.terminalId] ||
								{name: `Missing terminal : ${terminalSupplier.terminalId}`};
							terminalDisplay = terminal.name;
						}
						invoiceLines.push(`${netGallons} ${productType} : ${terminalDisplay}`);
						//invoiceE85 += parseInt(netGallons, 10);
					});
					//invoiceLines.push(<span><strong>{invoiceE85}</strong> gallons E85</span>);
				}
			}

			const carrier = carrierMap[carrierId] || {name: 'MISSING CARRIER'};
			let invoiceFuels = (<Fragment>
				<div>{carrier.name}</div>
				{invoiceLines.map((line, i) => {
					return (<div key={i}>{line}</div>);
				})}
			</Fragment>);

			//- Documents
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			const statusDisplay = statusToDisplay[status] || status;

			let issueMoment = moment(issueDate);
			let issueDateSort = issueMoment.format('YYYY-MM-DD');
			let issueDateDisplay = issueMoment.format('ddd, M/D');

			let invoicePdf = 'PDF';
			let onInvoiceClick = () => { this.onInvoiceClick(collatedResourceId); };
			let invoiceTotal = (<span>{moneyFormatter.format(stationInvoice.total)}</span>);
			let invoiceInfo = (<Fragment>
				<div>Issued : {issueDateDisplay}</div>
				<div>Total : {invoiceTotal}</div>
			</Fragment>);

			// for invoice search sometimes pending gets in there
			if (status === 'pending') {
				invoiceInfo = '';
				invoiceFuels = '';
			}

			return {
				stationInvoiceId,
				deliveryInfo,
				issueDateSort,
				issueDateDisplay,
				invoiceTotal,
				invoiceInfo,
				invoiceFuels,
				documentInfo,
				invoicePdf,
				quickbooksInvoiceUrl,
				onInvoiceClick,
				linkedStationDeliveryId,
				stationId,
				carrierId,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleRowClick(stationInvoiceId);
				}
			};
		});
	};

	formatIssuedBulkInvoices  = ({ bulkInvoices}) => {

		return bulkInvoices.map(bulkInvoice => {
			const {
				bulkCustomerMap,
				carrierMap,
				invoiceDocumentMap,
				bulkDeliveryMap,
				terminalMap,
				//resourceMap,
				supplierMap,
			} = this.props;

			const {
				bulkInvoiceId,
				linkedBulkDeliveryId,
				bulkCustomerId,
				carrierId,
				status,
				invoiceDocumentIds,
				issueDate,
				//dateCreated,
				collatedResourceId,
				quickbooksInvoiceUrl,
			} = bulkInvoice;

			const bulkCustomer = bulkCustomerMap[bulkCustomerId] ||
				{number: '', name: 'Missing bulk customer'};
			const bulkCustomerDisplay = `${bulkCustomer.name}`;

			//- Delivery
			const bulkDelivery = bulkDeliveryMap[linkedBulkDeliveryId];
			let deliveryInfo = (<span>Delivery {linkedBulkDeliveryId} not found</span>);
			if (bulkDelivery) {
				const {
					deliveryDate,
					bulkDeliveryId,
				} = bulkDelivery;

				const dateDisplay = moment(deliveryDate).format('ddd, M/D');
				deliveryInfo = (<Fragment>
					<div>{bulkCustomerDisplay}</div>
					<div>Delivery #{bulkDeliveryId}</div>
					<div>{dateDisplay}</div>
				</Fragment>);
			}


			//- Bulk Invoice
			const invoiceDocuments = invoiceDocumentIds.map(invoiceDocumentId => {
				return invoiceDocumentMap[invoiceDocumentId] || {name: 'MISSING'};
			});

			const {uploadedInvoiceDocuments, missingInvoiceDocuments} = getDocuments({
				bulkDelivery,
				carrierMap,
				terminalMap,
				supplierMap,
				invoiceDocuments,
			});


			let fuelInfo = null;
			const carrier = carrierMap[carrierId] || {name: 'MISSING CARRIER'};
			if (!_.isEmpty(missingInvoiceDocuments)) {
				fuelInfo = (<Fragment>
					<div>{carrier.name}</div>
					<div>No documents yet</div>
				</Fragment>);

			} else {
				const {pickupTerminalId, offloadTerminalId, pickupNetGallons, offloadNetGallons} = bulkInvoice;

				const pickupTerminal = terminalMap[pickupTerminalId] ||
					{name: `Missing terminal : ${pickupTerminalId}`};

				const offloadTerminal = terminalMap[offloadTerminalId] ||
					{name: `Missing terminal : ${offloadTerminalId}`};

				fuelInfo = (<Fragment>
					<div>{carrier.name}</div>
					<div>Pickup : {pickupNetGallons} from {pickupTerminal.name}</div>
					<div>Offload : {offloadNetGallons} to {offloadTerminal.name}</div>
				</Fragment>);
			}

			//- Documents
			let documentInfo = this.getDocumentInfo(uploadedInvoiceDocuments);
			const statusDisplay = statusToDisplay[status] || status;

			let issueMoment = moment(issueDate);
			let issueDateSort = issueMoment.format('YYYY-MM-DD');
			let issueDateDisplay = issueMoment.format('ddd, M/D');

			let invoicePdf = 'PDF';
			let onInvoiceClick = () => { this.onInvoiceClick(collatedResourceId); };
			let invoiceTotal = (<span>{moneyFormatter.format(bulkInvoice.total)}</span>);
			let invoiceInfo = (<Fragment>
				<div>Issued : {issueDateDisplay}</div>
				<div>Total : {invoiceTotal}</div>
			</Fragment>);

			return {
				bulkInvoiceId,
				deliveryInfo,
				issueDateSort,
				issueDateDisplay,
				invoiceTotal,
				invoiceInfo,
				fuelInfo,
				documentInfo,
				invoicePdf,
				quickbooksInvoiceUrl,
				onInvoiceClick,
				linkedBulkDeliveryId,
				bulkCustomerId,
				carrierId,
				status,
				statusDisplay,
				rowClick: () => {
					this.handleBulkRowClick(bulkInvoiceId, 'issued');
				}
			};
		});
	};

	getDocumentInfo = (uploadedInvoiceDocuments) => {
		const { classes, resourceMap } = this.props;


		if (_.isEmpty(uploadedInvoiceDocuments)) {
			return 'None yet';
		}

		//- Documents
		let left = 0;
		let zIndex = 100;
		return (<div
			className={classes.invoiceDocumentContainer}
			onClick={() => {
				this.onDocumentClick(uploadedInvoiceDocuments);
			}}
		>
			{uploadedInvoiceDocuments.map((invoiceDocument, i) => {
				left = i * 10;
				zIndex--;
				return (<div className={classes.invoiceDocument} style={{left, zIndex}} key={i}>
					<InvoiceDocumentIcon
						hasTooltip={false}
						invoiceDocument={invoiceDocument}
						resourceMap={resourceMap}
						onClick={_.noop}
					/>
				</div>);
			})
			}
		</div>);
	};

	handleRowClick = (stationInvoiceId) => {

		const { searchResultRows} = this.state;

		if (_.isEmpty(searchResultRows)) {
			return;
		}

		const viewStationInvoice = _.find(searchResultRows, {stationInvoiceId});

		this.setState({
			viewStationInvoice,
			isViewDialogOpen : true,
		});
	};

	handleBulkRowClick = (bulkInvoiceId) => {

		const { searchResultBulkRows} = this.state;

		if (_.isEmpty(searchResultBulkRows)) {
			return;
		}

		const viewBulkInvoice = _.find(searchResultBulkRows, {bulkInvoiceId});

		this.setState({
			viewBulkInvoice,
			isViewDialogOpen : true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({
			isViewDialogOpen : false,
			viewStationInvoice : undefined,
			bulkStationInvoice : undefined,
		});
	};

	handleCloseInvoiceDocumentPopup = () => {
		this.setState({
			isInvoiceDocumentPopupOpen : false,
			invoiceDocumentsPoppedUp : [],
		});
	};

	handleCloseInvoicePdfPopup = () => {
		this.setState({
			isInvoicePdfPopupOpen : false,
			invoicePdfPoppedUp : undefined,
		});
	};

	onDocumentClick = (invoiceDocuments) => {
		this.setState({
			isInvoiceDocumentPopupOpen : true,
			invoiceDocumentsPoppedUp : invoiceDocuments,
		});
	};

	onInvoiceClick = (resourceId) => {
		this.setState({
			isInvoicePdfPopupOpen : true,
			invoicePdfPoppedUp : resourceId,
		});
	};

	render () {
		const {
			classes,
			resourceMap,
		} = this.props;

		const {
			invoiceType,
			searchResultRows,
			searchResultBulkRows,
		} = this.state;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline label='Invoice Search' />
					<Paper className={classes.paper}>

						<FMPSelect
							label='Invoices to search'
							{...this.getInputProps('invoiceType')}
							options={[
								{ value : 'bulk', display : 'Bulk Invoices'},
								{ value : 'station', display : 'Station Invoices'},
							]}
						/>

						<div className={classes.divider} />
						{!invoiceType && <div className={classes.pickPlease}>
							Pick an invoice type first to see search parameters
						</div>}
						{invoiceType === 'station' && this.renderStationSearch()}
						{invoiceType === 'bulk' && this.renderBulkSearch()}
					</Paper>

					<Paper className={classes.paper}>
						{(_.isUndefined(searchResultRows) && _.isUndefined(searchResultBulkRows)) &&
						<div className={classes.resultsHere}>
							Results here
						</div>
						}
						{!_.isUndefined(searchResultRows) && this.renderResults()}
						{!_.isUndefined(searchResultBulkRows) && this.renderBulkResults()}

					</Paper>
				</Grid>


				<InvoiceDocumentPopup
					open={this.state.isInvoiceDocumentPopupOpen}
					onClose={this.handleCloseInvoiceDocumentPopup}
					invoiceDocuments={this.state.invoiceDocumentsPoppedUp}
					resourceMap={resourceMap}
				/>

				<InvoicePdfPopup
					open={this.state.isInvoicePdfPopupOpen}
					onClose={this.handleCloseInvoicePdfPopup}
					resourceId={this.state.invoicePdfPoppedUp}
					resourceMap={resourceMap}
				/>

				<ViewStationInvoiceLogDialog
					open={this.state.isViewDialogOpen}
					onClose={this.handleCloseViewDialog}
					stationInvoice={this.state.viewStationInvoice}
					history={this.props.history}
				/>

				<ViewBulkInvoiceLogDialog
					open={this.state.isViewDialogOpen}
					onClose={this.handleCloseViewDialog}
					bulkInvoice={this.state.viewBulkInvoice}
					history={this.props.history}
				/>
			</Grid>
		);
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order , orderBy });
	};

	handleEdit = (stationInvoiceId) => {
		this.props.history.push(`/accounting/stationInvoice/update/${stationInvoiceId}`);
	};

	handleBulkEdit = (bulkInvoiceId) => {
		this.props.history.push(`/accounting/bulkInvoice/update/${bulkInvoiceId}`);
	};

	renderResults = () => {
		const {
			canMakeUpdates,
			classes,
		} = this.props;

		const {
			searchResultRows,
			order,
			orderBy,
		} = this.state;

		const data = this.formatIssuedStationInvoices({
			stationInvoices:  searchResultRows,
		});
		const issuedRows = sortTable({data, order, orderBy });

		return (
			<Table size="small" className={classes.table}>
				<EnhancedTableHead
					columnData={stationColumns}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleSort}
				/>
				<TableBody>
					{issuedRows.map(row => {
						return (
							<PureRecordRow
								hover
								className={classes.row}
								key={row.stationInvoiceId}
							>
								<TableCell onClick={row.rowClick}>
									{row.stationInvoiceId}
								</TableCell>
								<TableCell onClick={row.rowClick}>
									{row.deliveryInfo}
								</TableCell>
								<TableCell onClick={row.rowClick}>
									{row.invoiceInfo}
								</TableCell>
								<TableCell onClick={row.rowClick}>
									{row.invoiceFuels}
								</TableCell>

								<TableCell>
									{row.documentInfo}
								</TableCell>
								<TableCell>
									{row.status === 'issued' &&
									<div
										className={classes.invoiceIcon}
										onClick={row.onInvoiceClick}
									/>}
								</TableCell>

								<TableCell>
									{row.status === 'issued' &&
									<a href={row.quickbooksInvoiceUrl} target="_blank" rel='noreferrer noopener'>
										<div className={classes.quickbooksIcon}/>
									</a>
									}
								</TableCell>

								<TableCell
									onClick={row.rowClick}
									className={classes[row.status]}
									style={{whiteSpace:'nowrap'}}
								>
									{row.statusDisplay}
								</TableCell>


								{canMakeUpdates &&
								<TableCell
									style={{whiteSpace:'nowrap'}}
								>
									<Button
										className={classes.button}
										onClick={() => this.handleEdit(row.stationInvoiceId)}
									>
										Edit
									</Button>
								</TableCell>
								}

							</PureRecordRow>
						);
					})}
				</TableBody>
			</Table>
		);
	};

	renderBulkResults = () => {
		const {
			canMakeUpdates,
			classes,
		} = this.props;

		const {
			searchResultBulkRows,
			order,
			orderBy,
		} = this.state;

		const data = this.formatIssuedBulkInvoices({
			bulkInvoices:  searchResultBulkRows,
		});
		const issuedRows = sortTable({data, order, orderBy });

		return (
			<Table size="small" className={classes.table}>
				<EnhancedTableHead
					columnData={bulkColumns}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleSort}
				/>
				<TableBody>
					{issuedRows.map(row => {
						return (
							<PureRecordRow
								hover
								className={classes.row}
								key={row.bulkInvoiceId}
							>
								<TableCell onClick={row.rowClick}>
									{row.bulkInvoiceId}
								</TableCell>
								<TableCell onClick={row.rowClick}>
									{row.deliveryInfo}
								</TableCell>
								<TableCell onClick={row.rowClick}>
									{row.invoiceInfo}
								</TableCell>
								<TableCell onClick={row.rowClick}>
									{row.fuelInfo}
								</TableCell>

								<TableCell>
									{row.documentInfo}
								</TableCell>
								<TableCell>
									<div
										className={classes.invoiceIcon}
										onClick={row.onInvoiceClick}
									/>
								</TableCell>

								<TableCell>
									<a href={row.quickbooksInvoiceUrl} target="_blank" rel='noreferrer noopener'>
										<div className={classes.quickbooksIcon} />
									</a>
								</TableCell>

								<TableCell
									onClick={row.rowClick}
									className={classes[row.status]}
									style={{whiteSpace:'nowrap'}}
								>
									{row.statusDisplay}
								</TableCell>


								{canMakeUpdates &&
								<TableCell
									style={{whiteSpace:'nowrap'}}
								>
									<Button
										className={classes.button}
										onClick={() => this.handleBulkEdit(row.bulkInvoiceId)}
									>
										Edit
									</Button>
								</TableCell>
								}

							</PureRecordRow>
						);
					})}
				</TableBody>
			</Table>
		);
	};

	renderStationSearch = () => {

		const { classes, stations, carriers, terminals, suppliers} = this.props;

		const { isSearching, productType, fuelPickupType } = this.state;

		return (<div>
			<FMPSectionHeader label={'Date Range'}/>

			<FMPDatePicker
				label='Delivery Date After'
				format={'MMMM Do, YYYY'}
				{...this.getInputProps('afterDate')}
			/>

			<FMPDatePicker
				label='Delivery Date Before'
				format={'MMMM Do, YYYY'}
				{...this.getInputProps('beforeDate')}
			/>

			<FMPSectionHeader label={'Delivery Info'}/>
			<FMPStationSelect
				label='Delivered to Station'
				{...this.getInputProps('stationId')}
				stations={stations}
			/>

			<FMPCarrierSelect
				label='Carrier'
				{...this.getInputProps('carrierId')}
				carriers={carriers}
			/>

			<FMPSectionHeader label={'Fuel'}/>

			<FMPProductSelect
				label='Fuel Type'
				productTypes={_.map(invoiceSearchProducts, ({ value }) => { return value; })}
				{...this.getInputProps('productType')}
			/>

			{!productType &&
			<Grid container spacing={3}>
				<Grid item md={8} style={{paddingTop : 25, display : 'flex'}}>
					<div className={classes.pickPlease}>
						If you want to search by terminal or supplier, pick the fuel type first
						to see the terminal and supplier options.
					</div>
				</Grid>
			</Grid>
			}

			{productType === 'e85' &&
			<Fragment>

				<FMPSelect
					{...this.getInputProps('fuelPickupType')}
					label="E85 fuel pickup option"
					options={[
						{display: 'Pickup E85 (single fuel pickup)', value: 'singleFuelPickup'},
						{display: 'Pickup UNL & ETOH (dual fuel pickup)', value: 'dualFuelPickup'}
					]}
				/>

				{!fuelPickupType &&
				<Grid container spacing={3}>
					<Grid item md={8} style={{paddingTop : 25, display : 'flex'}}>
						<div className={classes.pickPlease}>
							Please select an E85 fuel pickup option.
							E85 pickup shows a single terminal, while ETOH and UNL will give two optiosn
						</div>
					</Grid>
				</Grid>
				}


				{fuelPickupType === 'singleFuelPickup' &&
					<Fragment>
						<FMPTerminalSelect
							label='Terminal'
							{...this.getInputProps('firstTerminalTerminalId')}
							terminals={terminals}
							productTypes={[productType]}
						/>
						<FMPSupplierSelect
							label='Supplier'
							{...this.getInputProps('firstTerminalSupplierId')}
							suppliers={suppliers}
						/>
					</Fragment>
				}

				{fuelPickupType === 'dualFuelPickup' &&
				<Fragment>
					<FMPTerminalSelect
						label='Unleaded Terminal'
						{...this.getInputProps('firstTerminalTerminalId')}
						terminals={terminals}
						productTypes={['unl']}
					/>
					<FMPSupplierSelect
						label='Unleaded Supplier'
						{...this.getInputProps('firstTerminalSupplierId')}
						suppliers={suppliers}
					/>

					<FMPTerminalSelect
						label='Ethanol Terminal'
						{...this.getInputProps('secondTerminalTerminalId')}
						terminals={terminals}
						productTypes={['etoh']}
					/>
					<FMPSupplierSelect
						label='Ethanol Supplier'
						{...this.getInputProps('secondTerminalSupplierId')}
						suppliers={suppliers}
					/>
				</Fragment>
				}
			</Fragment>
			}

			{productType && productType !== 'e85' &&
			<Fragment>
				<FMPTerminalSelect
					label='Terminal'
					{...this.getInputProps('firstTerminalTerminalId')}
					terminals={terminals}
					productTypes={[productType]}
				/>
				<FMPSupplierSelect
					label='Supplier'
					{...this.getInputProps('firstTerminalSupplierId')}
					suppliers={suppliers}
				/>
			</Fragment>
			}


			<FMPSectionHeader label={'Document Fields'}/>

			<FMPText
				label='Carrier PO Number'
				{...this.getInputProps('carrierPoNumber')}
			/>

			<FMPText
				label='BOL Number'
				{...this.getInputProps('bolNumber')}
			/>

			<Grid container spacing={3}>
				<Grid item md={8} style={{paddingTop : 25, display : 'flex'}}>
					<Button
						className={classes.bigButton}
						variant="contained"
						color="primary"
						onClick={this.submitStationSearch}
					>
						<Search />
						RUN STATION INVOICE SEARCH
					</Button>

					{isSearching &&
						<div className={classes.runningSearch}>
							<CircularProgress/>
							<span style={{paddingLeft: 10}}>Searching...</span>
						</div>
					}
				</Grid>
			</Grid>

		</div>);
	};

	renderBulkSearch = () => {

		const { classes, bulkCustomers, carriers, terminals, suppliers} = this.props;

		const { isSearching } = this.state;

		return (<div>
			<FMPSectionHeader label={'Date Range'}/>

			<FMPDatePicker
				label='Delivery Date After'
				format={'MMMM Do, YYYY'}
				{...this.getInputProps('afterDate')}
			/>

			<FMPDatePicker
				label='Delivery Date Before'
				format={'MMMM Do, YYYY'}
				{...this.getInputProps('beforeDate')}
			/>

			<FMPSectionHeader label={'Delivery Info'}/>
			<FMPBulkCustomerSelect
				label='Bulk Customer'
				{...this.getInputProps('bulkCustomerId')}
				bulkCustomers={bulkCustomers}
			/>

			<FMPCarrierSelect
				label='Carrier'
				{...this.getInputProps('carrierId')}
				carriers={carriers}
			/>

			<FMPSectionHeader label={'Fuel Sources'}/>


			<FMPTerminalSelect
				label='Offload Terminal'
				{...this.getInputProps('offloadTerminalId')}
				terminals={terminals}
				productTypes={['etoh', 'unl']}
				justBulk={true}
			/>

			<FMPTerminalSelect
				label='Pickup Terminal'
				{...this.getInputProps('pickupTerminalId')}
				terminals={terminals}
				productTypes={['etoh', 'unl']}
				justBulk={true}
			/>

			<FMPSupplierSelect
				label='Pickup Supplier'
				{...this.getInputProps('pickupSupplierId')}
				suppliers={suppliers}
			/>

			<FMPSectionHeader label={'Document Fields'}/>
			<FMPText
				label='Carrier PO Number'
				{...this.getInputProps('carrierPoNumber')}
			/>

			<FMPText
				label='BOL Number'
				{...this.getInputProps('bolNumber')}
			/>

			<Grid container spacing={3}>
				<Grid item md={8} style={{paddingTop : 25, display : 'flex'}}>
					<Button
						className={classes.bigButton}
						variant="contained"
						color="primary"
						onClick={this.submitBulkSearch}
					>
						<Search />
						RUN BULK INVOICE SEARCH
					</Button>

					{isSearching &&
					<div className={classes.runningSearch}>
						<CircularProgress/>
						<span style={{paddingLeft: 10}}>Searching...</span>
					</div>
					}
				</Grid>
			</Grid>
		</div>);
	}
}

InvoiceSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors : PropTypes.func.isRequired,
	history : PropTypes.object,
	canMakeUpdates : PropTypes.bool,

	bulkCustomers : PropTypes.array,
	searchBulkCustomers : PropTypes.func.isRequired,

	advancedSearchStationInvoices : PropTypes.func.isRequired,
	advancedSearchBulkInvoices : PropTypes.func.isRequired,

	stations : PropTypes.array,
	searchStations : PropTypes.func.isRequired,

	carriers : PropTypes.array,
	searchCarriers : PropTypes.func.isRequired,

	terminals : PropTypes.array,
	searchTerminals : PropTypes.func.isRequired,

	suppliers : PropTypes.array,
	searchSuppliers : PropTypes.func.isRequired,

	accessToken : PropTypes.string,

	stationMap : PropTypes.object,
	carrierMap : PropTypes.object,
	invoiceDocumentMap : PropTypes.object,
	stationDeliveryMap : PropTypes.object,
	terminalMap : PropTypes.object,
	supplierMap : PropTypes.object,
	bulkCustomerMap : PropTypes.object,
	bulkDeliveryMap : PropTypes.object,
	resourceMap : PropTypes.object,
};

export default _.flow([
	withStyles(styles),
	StationInvoicesContainer,
	BulkInvoicesContainer,
	BulkCustomersContainer,
	StationsContainer,
	CarriersContainer,
	TerminalsContainer,
	SuppliersContainer,
])(InvoiceSearch);
